import React, { useState, useEffect } from 'react';
import { TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import GridItem from 'components/Grid/GridItem';
import { ESTADOS } from './estados';

/**
 * Filtro por estado del control.
 *
 * Mismo molde que FilterFurnitureCategory: avisa hacia arriba con getValue y
 * consulta al instante, porque es un combo y no hay nada que terminar de
 * escribir. La "x" de limpiar la pone el propio Autocomplete.
 */
export default function FilterFurnitureState({ value, getValue, getData }) {
  const [selected, setSelected] = useState(null);

  //si el padre limpia los filtros, el combo se limpia con él
  useEffect(() => {
    if (!value?.state) setSelected(null);
  }, [value]);

  return (
    <GridItem xs={12} lg={3}>
      <Autocomplete
        options={ESTADOS}
        value={selected}
        getOptionLabel={(option) => option.descripcion || ''}
        getOptionSelected={(option, val) => option.id === val.id}
        renderInput={(params) => (
          <TextField {...params} placeholder="Estado" margin="normal" fullWidth />
        )}
        onChange={(e, item) => {
          setSelected(item);
          const nuevo = { ...value, state: item ? item.id : undefined };
          if (!item) delete nuevo.state;
          getValue(nuevo);
          getData(nuevo);
        }}
      />
    </GridItem>
  );
}
